import { stringify } from "query-string";
import { DataPhoto } from "../models/UploadPhotosModel";
import { convertToBase64 } from "../utils/helper";
import { httpClientJwt } from "./httpClientJwt";
import { API_ENDPOINT_PATH, FRONT_IMAGES_PATH } from "../utils/const";
import { lowerFirst } from "lodash";
import configData from "./../config.json";

const apiUrl = configData.ServerUrl as string;

export default {
  getList: async (resource: any, params: any) => {
    const { page, perPage } = params.pagination;
    const { field, order } = params.sort;
    const query = {
      _page: page,
      _perPage: perPage,
      _sort: field,
      _order: order,
      // range: JSON.stringify([(page - 1) * perPage, page * perPage - 1]),
    };

    const url = `${apiUrl}?${stringify(query)}`;

    const { json } = await httpClientJwt(url);
    if (!json) {
      throw new Error("No response data");
    }
    return {
      data: json.docs,
      total: json.count,
    };
  },

  getOne: async (resource: any, params: any) => {
    const url = `${apiUrl}/${resource}/${params.id}`;
    const { json } = await httpClientJwt(url);
    return { data: json };
  },

  getMany: async (resource: any, params: any) => {
    const query = {
      filter: JSON.stringify({ id: params.ids }),
    };
    const url = `${apiUrl}/${resource}?${stringify(query)}`;
    const { json } = await httpClientJwt(url);
    if (!json) {
      throw new Error("No response data");
    }
    return { data: json.docs };
  },

  getManyReference: async (resource: any, params: any) => {
    const { page, perPage } = params.pagination;
    const { field, order } = params.sort;
    const query = {
      sort: JSON.stringify([field, order]),
      range: JSON.stringify([(page - 1) * perPage, page * perPage - 1]),
      filter: JSON.stringify({
        ...params.filter,
        [params.target]: params.id,
      }),
    };
    const url = `${apiUrl}/${resource}?${stringify(query)}`;
    const { json } = await httpClientJwt(url);
    if (!json) {
      throw new Error("No response data");
    }
    return {
      data: json.docs,
      total: json.count,
    };
  },

  update: async (resource: any, params: any) => {
    const url = `${apiUrl}/${resource}/${params.id}`;
    const { json } = await httpClientJwt(url, {
      method: "PUT",
      body: JSON.stringify(params.data),
    });
    return { data: json };
  },

  updateMany: async (resource: any, params: any) => {
    const query = {
      filter: JSON.stringify({ id: params.ids }),
    };
    const url = `${apiUrl}/${resource}?${stringify(query)}`;
    const { json } = await httpClientJwt(url, {
      method: "PUT",
      body: JSON.stringify(params.data),
    });
    return { data: json };
  },

  create: async (resource: string, params: DataPhoto): Promise<any> => {
    if (resource === API_ENDPOINT_PATH) {
      const file = params.data.rawData;
      const base64File = await convertToBase64(file);
      params.data.rawData = base64File;
    }
    const { json } = await httpClientJwt(`${apiUrl}`, {
      method: "POST",
      body: JSON.stringify(params.data),
    });
    return {
      data: { ...params.data, id: json.id },
    };
  },

  delete: (resource: string, params: any) => {
    const request = httpClientJwt(`${apiUrl}?imageId=${params.id}`, {
      method: "DELETE",
    }).then(({ json }) => ({ data: json }));
    return request;
  },

  deleteMany: (resource: string, params: any) => {
    const query = {
      filter: JSON.stringify({ id: params.ids }),
    };
    return httpClientJwt(`${apiUrl}/${resource}?${stringify(query)}`, {
      method: "DELETE",
      body: JSON.stringify(params.data),
    }).then(({ json }) => ({ data: json }));
  },
};
